var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthCare2ULogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "HealthCare2u_-_Logo",
    "data-name": "HealthCare2u - Logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 154.979,
    height: 75.834,
    viewBox: "0 0 154.979 75.834",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bottom_Left_Square",
    "data-name": "Bottom Left Square",
    width: 26.887,
    height: 26.938,
    transform: "translate(39.642 48.896)",
    fill: "#9e3223"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Top_Left_Square",
    "data-name": "Top Left Square",
    width: 26.887,
    height: 26.937,
    transform: "translate(39.642)",
    fill: "#9e3223"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bottom_Right_Square",
    "data-name": "Bottom Right Square",
    width: 26.888,
    height: 26.938,
    transform: "translate(88.448 48.896)",
    fill: "#9e3223"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Top_Right_Square",
    "data-name": "Top Right Square",
    width: 26.888,
    height: 26.937,
    transform: "translate(88.448)",
    fill: "#9e3223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H1",
    d: "M416.488,157.676h2.674v3.111H424.8v-3.111h2.674v8.735H424.8V163.1h-5.636v3.307h-2.674Z",
    transform: "translate(-416.488 -123.437)",
    fill: "#0d123b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E1",
    d: "M424.009,157.676h9.538V159.7h-6.864v1.4h6.5v1.81h-6.5v1.4h7.02v2.1h-9.694Z",
    transform: "translate(-410.015 -123.437)",
    fill: "#0d123b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A1",
    d: "M434.995,157.676h3.481l4.793,8.735h-2.975l-.83-1.545h-5.42l-.783,1.545h-2.986Zm.048,5.309h3.42l-1.734-3.283Z",
    transform: "translate(-404.623 -123.437)",
    fill: "#0d123b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L",
    d: "M438.416,157.676h2.674v6.491h6.01v2.244h-8.684Z",
    transform: "translate(-397.616 -123.437)",
    fill: "#0d123b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T",
    d: "M443.278,157.676h10.189v2.172h-3.759v6.563h-2.674v-6.563h-3.757Z",
    transform: "translate(-393.431 -123.437)",
    fill: "#0d123b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H2",
    d: "M450.028,157.676H452.7v3.111h5.636v-3.111h2.674v8.735h-2.674V163.1H452.7v3.307h-2.674Z",
    transform: "translate(-387.622 -123.437)",
    fill: "#0d123b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M457.445,160.786c0-2.559,1.435-3.161,3.842-3.161h3.144c3.805,0,4.3.82,4.276,3.294h-2.676v-.242c0-.626-.456-.807-1.252-.807h-2.914c-1.409,0-1.675.664-1.675,1.749v.941c0,1.268.266,1.75,1.53,1.75h2.854c1.206,0,1.567-.121,1.567-1.208h2.674v.82c0,1.473-.53,2.632-3.215,2.632h-4.313c-2.408,0-3.842-.6-3.842-3.161Z",
    transform: "translate(-381.239 -123.482)",
    fill: "#0d123b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A2",
    d: "M469.332,157.676h3.479l4.793,8.735H474.63l-.83-1.545h-5.42l-.781,1.545H464.61Zm.047,5.309H472.8l-1.734-3.283Z",
    transform: "translate(-375.072 -123.437)",
    fill: "#0d123b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R",
    d: "M472.752,157.676h8.07c2.06,0,2.614,1.025,2.614,2.593v.555c0,1.171-.266,1.858-1.494,2.147V163c.795.145,1.457.494,1.457,1.931v1.484h-2.674v-1.049c0-.917-.264-1.219-1.1-1.219h-4.2v2.269h-2.674Zm2.674,4.295h4.421c.722,0,.988-.289.988-.917v-.289c0-.774-.387-.917-1.23-.917h-4.179Z",
    transform: "translate(-368.065 -123.437)",
    fill: "#0d123b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E2",
    d: "M480.111,157.676h9.54V159.7h-6.866v1.4h6.5v1.81h-6.5v1.4h7.022v2.1h-9.7Z",
    transform: "translate(-361.731 -123.437)",
    fill: "#0d123b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_2",
    "data-name": 2,
    d: "M486.8,161.43c0-1.074.7-1.786,2.423-1.907l3.057-.194c1.952-.119,2.084-.157,2.084-1.012,0-.712-.071-.869-1.783-.869h-1.769c-1.131,0-1.481.168-1.481,1.074v.373H486.8V157.87c0-1.724,1.012-2.3,3.422-2.3h3.517c2.5,0,3.156.747,3.156,2.571,0,2.569-.471,3-3.589,3.173l-2.759.145c-1.118.06-1.288.276-1.288,1.061h7.757V164.4H486.8Z",
    transform: "translate(-355.972 -125.26)",
    fill: "#9e3223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U",
    d: "M493.878,157.676h2.674v5.042c0,1.111.4,1.545,1.492,1.545h2.65c1.1,0,1.494-.434,1.494-1.545v-5.042h2.674V163.3c0,2.172-1.12,3.21-3.578,3.21h-3.829c-2.458,0-3.576-1.038-3.576-3.21Z",
    transform: "translate(-349.883 -123.437)",
    fill: "#0d123b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthCare2ULogo);
export default __webpack_public_path__ + "static/media/HealthCare2u_Logo.5bdb773b74f8daee4934386f060ed0ce.svg";
export { ForwardRef as ReactComponent };